export const usei18nService = () => {
	const { $i18n } = useNuxtApp()
	const locale = $i18n.locale
	const locales = $i18n.locales
	const localeLang = useCookie('langRedirection')
	const localePath = useLocalePath()
	const route = useRoute()
	const $t = (key: string) => $i18n.t(key).toString()

	const getLocaleLang = () => {
		if (!localeLang.value && process.client) {
			localeLang.value = 'pl'
		}
		return locale.value
	}

	const getLocaleLangs = () => {
		return locales
	}

	const localeString = (str: string | Ii18n) => {
		return typeof str === 'string' ? str : str[locale.value]
	}

	const $tDynamic = (path: string, key: string) => {
		if (!path || !key) return ''

		// check if city
		const cityTranslationKey = key
			.toLowerCase()
			.split('')
			.map((char) => polishToEnglish[char] || char)
			.join('')
			.replace(/ /g, '_')

		if ($t(`data.cities.${cityTranslationKey}`) !== `data.cities.${cityTranslationKey}`) {
			return $t(`data.cities.${cityTranslationKey}`)
		}

		if ($t(`${path}.${key}`) === `${path}.${key}`) {
			return key
		} else {
			return $t(`${path}.${key}`)
		}
	}

	const changeLang = (lang: string, urlSlice?: string) => {
		const currentRouteName = route.name
		let pathToRedirect = ''

		// handle pl lang - no prefix in that case
		if (lang === 'pl' && currentRouteName?.includes('index')) {
			pathToRedirect = localePath('/', lang)
		} else if (currentRouteName?.includes('news-newsID-newsTitle') || route.fullPath.includes('wypozyczalnia-samochodow-elektrycznych')) {
			pathToRedirect = localePath('/', lang)
		} else {
			pathToRedirect = urlSlice
				? localePath({ name: currentRouteName?.toString().slice(0, -5), params: { urlSlug: urlSlice } }, lang)
				: localePath(currentRouteName?.toString().slice(0, -5), lang)
		}

		// const langCookie = useCookie('langRedirection')
		// langCookie.value = lang

		window.location.replace(pathToRedirect)
	}

	const convertToKeyFormat = (inputString: string, maxWords = 6) => {
		if (!inputString || typeof inputString !== 'string') return ''
		const words = inputString
			.toLowerCase()
			.split(/[^a-z0-9]+/)
			.filter((word) => word !== '') // Split and filter out empty strings

		const truncatedWords = words.slice(0, maxWords)

		return truncatedWords.join('_')
	}

	const polishToEnglish = {
		ą: 'a',
		ć: 'c',
		ę: 'e',
		ł: 'l',
		ń: 'n',
		ó: 'o',
		ś: 's',
		ź: 'z',
		ż: 'z',
		Ą: 'a',
		Ć: 'c',
		Ę: 'e',
		Ł: 'l',
		Ń: 'n',
		Ó: 'o',
		Ś: 's',
		Ź: 'z',
		Ż: 'z',
	}

	return {
		getLocaleLangs,
		getLocaleLang,
		localeString,
		changeLang,
		convertToKeyFormat,
		$tDynamic,
	}
}
